import React, { useState } from 'react';

import { NOT_SET } from '../workforce/assumption/recruitmentStatusCategories';

import Button from 'CommonComponents/Button';

import TrashIcon from 'Assets/icons/trash.svg';

/** Actions on the selected positions; `count` includes every selected group member. */
export default function PositionsBulkBar({ count, statuses, showStatus, isApplying, canDelete, onApplyStatus, onDelete, onClear }) {
    const [target, setTarget] = useState('');

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-blue-25 tw-bg-blue-10 tw-px-3 tw-py-2 tw-text-xs">
            <span>{$t('{{count}} selected', { count })}</span>
            {showStatus && (
                <>
                    <label htmlFor="positions-bulk-status" className="tw-mb-0">
                        {$t('Set status to')}
                    </label>
                    <select
                        id="positions-bulk-status"
                        aria-label={$t('Set status to')}
                        className="select select-input !tw-bg-white !tw-border !tw-w-auto"
                        value={target}
                        onChange={(e) => setTarget(e.target.value)}
                    >
                        <option value="" disabled>
                            {$t('Choose a status')}
                        </option>
                        <option value={NOT_SET}>{$t('Not set')}</option>
                        {statuses
                            .filter((status) => status.is_active)
                            .map((status) => (
                                <option value={status.id} key={status.id}>
                                    {status.name}
                                </option>
                            ))}
                    </select>
                    <Button
                        variant="primary"
                        small
                        className="edit-locked-budget-entity"
                        loading={isApplying}
                        disabled={isApplying || target === ''}
                        onClick={() => onApplyStatus(target === NOT_SET ? null : Number(target))}
                    >
                        {$t('Apply')}
                    </Button>
                </>
            )}
            <Button
                variant="outline-danger"
                small
                className="edit-locked-budget-entity"
                disabled={!canDelete}
                title={canDelete ? undefined : $t('You cannot delete every selected position')}
                onClick={onDelete}
            >
                <TrashIcon className="tw-w-3 tw-h-3" aria-hidden="true" />
                {$t('Delete selected')}
            </Button>
            <button type="button" className="tw-ms-auto tw-text-charcoal-50 hover:tw-text-charcoal" onClick={onClear}>
                {$t('Clear')}
            </button>
        </div>
    );
}
